import { gql } from 'apollo-boost';

export const DOWNLOAD_URL_INFO_DUMP = gql`
    mutation($data: DownloadUrlInfoDumpInput!) {
        downloadUrlInfoDump(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
